import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchDashboard,
  fetchVisibility,
  fetchVisibilityPerSales,
  selectDataDashboard,
  selectDataSynch,
  selectDataVisibility,
  selectDataVisibilityPerSales,
  selectEndDateDashboard,
  selectLoading,
  selectLoading2,
  selectStartDateDashboard,
} from "./company/companySlice";
import {
  colorsPie,
  defaultDate,
  filterDataDesc,
  formatCurrency,
  formatQuantity,
  getRandomBorderColor,
  getRandomColor,
  statusFormatter,
} from "../utility";
import {
  headerSortingClasses,
  sortCaret,
  toAbsoluteUrl,
} from "../../_metronic/_helpers";
import SVG from "react-inlinesvg";

import { LayoutSplashScreen } from "../../_metronic/layout";
import { NavLink } from "react-router-dom";

import {
  Doughnut,
  Bar,
  getDatasetAtEvent,
  getElementAtEvent,
  getElementsAtEvent,
  Pie,
} from "react-chartjs-2";
import {
  Button,
  Col,
  Modal,
  OverlayTrigger,
  Row,
  Tooltip as BootstrapTooltip, // Alias untuk Tooltip dari react-bootstrap
} from "react-bootstrap";
import {
  Chart as ChartJS,
  ArcElement,
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  LineController,
  BarController,
} from "chart.js";
import {
  Card,
  CardBody,
  CardHeaderTitle,
} from "../../_metronic/_partials/controls";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { useHistory } from "react-router-dom";
import { CardHeader } from "@material-ui/core";
import {
  FaAngleDoubleDown,
  FaAngleDoubleUp,
  FaAngleDown,
  FaAngleUp,
} from "react-icons/fa";
import { Stepper, Step } from "react-form-stepper";

export const DashboardPage = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const data = useSelector(selectDataDashboard);
  const dataVisibility = useSelector(selectDataVisibility);
  const dataVisibilityPerSales = useSelector(selectDataVisibilityPerSales);
  const loading = useSelector(selectLoading);
  const [tableDataCustomer, setTableDataCustomer] = useState([]);
  const [tableDataProduct, setTableDataProduct] = useState([]);
  const [tableDataSales, setTableDataSales] = useState([]);
  const [tableDataVisibility, setTableDataVisibility] = useState([]);
  const [
    tableDataVisibilityPerSales,
    setTableDataVisibilityPerSales,
  ] = useState([]);
  const [tableDataSalesDetail, setTableDataSalesDetail] = useState([]);
  const [sales, setSales] = useState([]);
  const [targetCall, setTargetCall] = useState([]);
  const [effectiveCall, setEffectiveCall] = useState([]);
  const [actualCall, setActualCall] = useState([]);
  const [revenue, setRevenue] = useState([]);
  const [rowData, setRowData] = useState(null);
  const [showVisibilityData, setShowVisibilityData] = useState(false);

  const startDateDashboard = useSelector(selectStartDateDashboard);
  const endDateDashboard = useSelector(selectEndDateDashboard);

  const [show, setShow] = useState(false);
  const [showVisibility, setShowVisibility] = useState(false);
  const [showTargetDetail, setShowTargetDetail] = useState(false);
  const { SearchBar } = Search;

  const [activeStep, setActiveStep] = useState(0);

  const handleNextStep = () => setActiveStep((prev) => prev + 1);
  const handlePreviousStep = () => setActiveStep((prev) => prev - 1);

  const _startDate =
    startDateDashboard === null ? defaultDate : startDateDashboard;
  const _endDate = endDateDashboard === null ? defaultDate : endDateDashboard;

  const handleClose = () => {
    setShow(false);
    setTableDataSalesDetail([]);
  };

  const handleCloseVisibility = () => {
    setShowVisibility(false);
    setShowVisibilityData(false);
  };

  const toggleVisiblityDetail = () => {
    setShowTargetDetail(showTargetDetail ? false : true);
  };

  // Register the elements you are using
  ChartJS.register(
    ChartDataLabels,
    ArcElement,
    LinearScale,
    CategoryScale,
    BarElement,
    PointElement,
    LineElement,
    Legend,
    Tooltip,
    LineController,
    BarController
  );

  useEffect(() => {
    async function fetchMyAPI() {
      await dispatch(
        fetchDashboard({ start_date: defaultDate, end_date: defaultDate })
      );
    }
    fetchMyAPI();
  }, [dispatch]);

  useEffect(() => {
    if (!data) return;

    // Helper function to map and add 'no'
    const addNoField = (items) =>
      items.map((item, index) => ({ ...item, no: index + 1 }));

    // Process customers, products, and visit_statistics
    const initDataCustomer = addNoField(data.customers || []);
    const initDataProduct = addNoField(data.products || []);
    const initDataSales = addNoField(data.visit_statistics || []).map(
      (item) => ({
        ...item,
        sales_name: `${item.company_sales_code}-${item.company_sales_name}`,
      })
    );

    // Process and sort sales data
    const sortedSales = [...(data.sales || [])].sort(
      (a, b) => parseInt(b.effective_call) - parseInt(a.effective_call)
    );
    const initSalesData = {
      sales: sortedSales.map((item) => item.company_sales_name),
      effectiveCalls: sortedSales.map((item) => item.effective_call),
      actualCalls: sortedSales.map((item) => item.actual_call),
      targetCalls: sortedSales.map((item) => item.target_call),
      revenues: sortedSales.map((item) => item.revenue),
    };

    // Update state
    setTableDataCustomer(initDataCustomer);
    setTableDataProduct(initDataProduct);
    setTableDataSales(initDataSales);
    setSales(initSalesData.sales);
    setEffectiveCall(initSalesData.effectiveCalls);
    setActualCall(initSalesData.actualCalls);
    setTargetCall(initSalesData.targetCalls);
    setRevenue(initSalesData.revenues);
  }, [data]);

  useEffect(() => {
    if (!dataVisibility) return;

    // Helper function to map and add 'no'
    const addNoField = (items) =>
      items.map((item, index) => ({ ...item, no: index + 1 }));

    // Process customers, products, and visit_statistics
    const initData = addNoField(dataVisibility || []);
    setTableDataVisibility(initData);
  }, [dataVisibility]);

  useEffect(() => {
    if (!dataVisibilityPerSales) return;

    // Helper function to map and add 'no'
    const addNoField = (items) =>
      items.map((item, index) => ({ ...item, no: index + 1 }));

    // Process customers, products, and visit_statistics
    const initData = addNoField(dataVisibilityPerSales || []);
    setTableDataVisibilityPerSales(initData);
  }, [dataVisibilityPerSales]);

  const dataHadrcode = {
    labels: sales,
    datasets: [
      {
        label: "Targel Call",
        borderWidth: 1,
        backgroundColor: "rgb(220, 38, 38)",
        hoverBorderColor: "rgba(75,192,192,1)",
        data: targetCall,
      },
      {
        label: "Actual Call",
        borderWidth: 1,
        backgroundColor: "rgb(255, 168, 0)",
        hoverBorderColor: "rgba(75,192,192,1)",
        data: actualCall,
      },
      {
        label: "Efective Call",
        borderWidth: 1,
        backgroundColor: "rgb(27, 197, 189)",
        hoverBorderColor: "rgb(27, 197, 189)",
        data: effectiveCall,
      },
    ],
  };

  const options = {
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
      legend: {
        // display: false,
        position: "bottom",
      },
      title: {
        display: true,
      },
      datalabels: {
        display: true,
        color: "white", // Set the text color to white
        align: "center",
        anchor: "center",
        formatter: function(value, context) {
          return value;
        },
      },
    },
  };

  const optionsPie = {
    maintainAspectRatio: false,
    responsive: true,

    plugins: {
      legend: {
        // display: false,
        position: "bottom",
      },
      title: {
        display: true,
        align: "start",
        text: "Revenue",
        font: {
          size: 20,
        },
        style: "italic",
        padding: {
          top: 10,
          bottom: 30,
        },
      },
      datalabels: {
        display: true,
        color: "white", // Set the text color to white
        align: "center",
        anchor: "center",
        formatter: function(value, context) {
          // Format the value as currency (in Rupiah)
          return new Intl.NumberFormat("id-ID", {
            style: "currency",
            currency: "IDR",
            minimumFractionDigits: 0,
          }).format(value);
        },
      },
    },
    z: {
      stacked: true,
    },
  };
  const dataPie = {
    labels: sales,
    datasets: [
      {
        label: "Revenue",
        data: revenue,
        backgroundColor: colorsPie,
        borderWidth: 1,
      },
    ],
  };

  const columns = [
    {
      text: "No",
      dataField: "no",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "60px" },
      footer: "",
    },
    {
      text: "sales name",
      dataField: "sales_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      footer: "",
    },
    {
      text: "target call",
      dataField: "target_call",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      align: "right",
      style: { minWidth: "180px" },
      footer: (columnData) => {
        const parsedData = columnData.map((item) => parseFloat(item));
        const total = parsedData.reduce((acc, item) => acc + item, 0);
        if (total === 0) {
          return null; // Menyembunyikan footer jika total harga adalah 0
        }
        return formatQuantity(total);
      },
      footerAlign: (column, colIndex) => "right",
    },
    {
      text: "actual call",
      dataField: "actual_call",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      align: "right",
      style: { minWidth: "180px" },
      footer: (columnData) => {
        const parsedData = columnData.map((item) => parseFloat(item));
        const total = parsedData.reduce((acc, item) => acc + item, 0);
        if (total === 0) {
          return null; // Menyembunyikan footer jika total harga adalah 0
        }
        return formatQuantity(total);
      },
      footerAlign: (column, colIndex) => "right",
    },
    {
      text: "pending call",
      dataField: "pending_call",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      align: "right",
      style: { minWidth: "180px" },
      footer: (columnData) => {
        const parsedData = columnData.map((item) => parseFloat(item));
        const total = parsedData.reduce((acc, item) => acc + item, 0);
        if (total === 0) {
          return null; // Menyembunyikan footer jika total harga adalah 0
        }
        return formatQuantity(total);
      },
      footerAlign: (column, colIndex) => "right",
    },
    {
      text: "effective call",
      dataField: "effective_call",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      align: "right",
      style: { minWidth: "180px" },
      footer: (columnData) => {
        const parsedData = columnData.map((item) => parseFloat(item));
        const total = parsedData.reduce((acc, item) => acc + item, 0);
        if (total === 0) {
          return null; // Menyembunyikan footer jika total harga adalah 0
        }
        return formatQuantity(total);
      },
      footerAlign: (column, colIndex) => "right",
    },
    {
      text: "revenue",
      dataField: "revenue",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      align: "right",
      formatter: formatCurrency,
      footer: (columnData) => {
        const parsedData = columnData.map((item) => parseFloat(item));
        const total = parsedData.reduce((acc, item) => acc + item, 0);
        if (total === 0) {
          return null; // Menyembunyikan footer jika total harga adalah 0
        }
        return formatCurrency(total);
      },
      footerAlign: (column, colIndex) => "right",
    },
  ];

  const actionVisibilityFormatter = (e, row) => {
    return (
      <div>
        <OverlayTrigger
          overlay={
            <BootstrapTooltip id={`tooltip-${row.user_id}`}>
              View Detail
            </BootstrapTooltip>
          }
        >
          <button
            className="btn btn-icon btn-light btn-hover-danger btn-sm mr-3"
            onClick={() => {
              setRowData(row);
              setShowVisibilityData(true);
              dispatch(
                fetchVisibilityPerSales({
                  start_date: _startDate,
                  end_date: _endDate,
                  type: "per_sales",
                  user_id: row.user_id,
                })
              );
              handleNextStep();
            }}
          >
            <span className="svg-icon svg-icon-md svg-icon-secondary">
              <SVG src={toAbsoluteUrl("/media/svg/icons/General/Search.svg")} />
            </span>
          </button>
        </OverlayTrigger>
      </div>
    );
  };

  const columnsVisibility = [
    {
      text: "No",
      dataField: "no",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "60px" },
    },

    {
      text: "Sales",
      dataField: "name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },

    {
      text: "display",
      dataField: "display",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "80px" },
    },
    {
      text: "Action",
      dataField: "action",
      align: "center",
      formatter: actionVisibilityFormatter,
      style: { minWidth: "120px" },
      align: "center",
    },
  ];

  const columnsVisibilityPerSales = [
    {
      text: "No",
      dataField: "no",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "60px" },
    },
    {
      text: "Sales",
      dataField: "name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
    {
      text: "customer code",
      dataField: "customer_code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },

    {
      text: "store name",
      dataField: "customer_store_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "80px" },
    },
    {
      text: "display",
      dataField: "display",
      align: "center",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "80px" },
    },
  ];

  const columnsDetail = [
    {
      text: "product",
      dataField: "product_code",
      style: { minWidth: "120px" },
    },
    {
      text: "product name",
      dataField: "product_name",
      style: { minWidth: "120px" },
    },
    {
      text: "visibility",
      dataField: "visibility",
      style: { minWidth: "120px" },
      formatter: statusFormatter,
      align: "center",
    },
  ];

  const expandRow = {
    expandByColumnOnly: true,
    showExpandColumn: true,
    // expanded: [0, 1],
    renderer: (row) => (
      <BootstrapTable
        keyField="product_code"
        data={row.products === null ? [] : row.products}
        columns={columnsDetail}
      />
    ),
    expandColumnRenderer: ({ expanded }) =>
      expanded ? <FaAngleUp /> : <FaAngleDown />,
    expandHeaderColumnRenderer: ({ isAnyExpands }) =>
      isAnyExpands ? <FaAngleDoubleUp /> : <FaAngleDoubleDown />,
    align: "center",
  };

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <div>
        <Row>
          <Col className="mt-3">
            <div className={`card card-custom fixed-height`}>
              <div className="card-body p-0">
                <div className="d-flex align-items-center justify-content-between card-spacer flex-grow-1">
                  <span
                    className={`symbol symbol-50 symbol-light-secondary mr-2`}
                  >
                    <span className="symbol-label">
                      <span className={`svg-icon svg-icon-xl svg-icon-danger`}>
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Map/Marker1.svg"
                          )}
                        ></SVG>
                      </span>
                    </span>
                  </span>
                  <div className="d-flex flex-column text-right">
                    <span className="text-dark-75 font-weight-bolder font-size-h3">
                      {data?.target_call}
                    </span>
                    <span
                      className="text-muted font-weight-bold mt-2"
                      onClick={() => setShow(true)}
                      style={{ cursor: "pointer" }}
                    >
                      Target Call
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </Col>
          <Col className="mt-3">
            <div className={`card card-custom fixed-height`}>
              <div className="card-body p-0">
                <div className="d-flex align-items-center justify-content-between card-spacer flex-grow-1">
                  <span
                    className={`symbol symbol-50 symbol-light-secondary mr-2`}
                  >
                    <span className="symbol-label">
                      <span className={`svg-icon svg-icon-xl svg-icon-warning`}>
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Map/Location-arrow.svg"
                          )}
                        ></SVG>
                      </span>
                    </span>
                  </span>
                  <div className="d-flex flex-column text-right">
                    <span className="text-dark-75 font-weight-bolder font-size-h3">
                      {data?.actual_call}
                    </span>
                    <span
                      className="text-muted font-weight-bold mt-2"
                      onClick={() => setShow(true)}
                      style={{ cursor: "pointer" }}
                    >
                      Actual Call
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </Col>
          <Col className="mt-3">
            <div className={`card card-custom fixed-height`}>
              <div className="card-body p-0">
                <div className="d-flex align-items-center justify-content-between card-spacer flex-grow-1">
                  <span
                    className={`symbol symbol-50 symbol-light-secondary mr-2`}
                  >
                    <span className="symbol-label">
                      <span className={`svg-icon svg-icon-xl svg-icon-danger`}>
                        <SVG
                          src={toAbsoluteUrl("/media/svg/icons/Home/Clock.svg")}
                        ></SVG>
                      </span>
                    </span>
                  </span>
                  <div className="d-flex flex-column text-right">
                    <span className="text-dark-75 font-weight-bolder font-size-h3">
                      {data?.pending_call}
                    </span>
                    <span
                      className="text-muted font-weight-bold mt-2"
                      onClick={() => setShow(true)}
                      style={{ cursor: "pointer" }}
                    >
                      Pending Call
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>

        <Row>
          <Col className="mt-3">
            <div className={`card card-custom fixed-height`}>
              <div className="card-body p-0">
                <div className="d-flex align-items-center justify-content-between card-spacer flex-grow-1">
                  <span
                    className={`symbol symbol-50 symbol-light-secondary mr-2`}
                  >
                    <span className="symbol-label">
                      <span className={`svg-icon svg-icon-xl svg-icon-danger`}>
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Map/Direction2.svg"
                          )}
                        ></SVG>
                      </span>
                    </span>
                  </span>
                  <div className="d-flex flex-column text-right">
                    <span className="text-dark-75 font-weight-bolder font-size-h3">
                      {data?.effective_call}
                    </span>
                    <span
                      className="text-muted font-weight-bold mt-2"
                      onClick={() => setShow(true)}
                      style={{ cursor: "pointer" }}
                    >
                      Effective Call
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </Col>
          <Col className="mt-3">
            <div className={`card card-custom fixed-height`}>
              <div className="card-body p-0">
                <div className="d-flex align-items-center justify-content-between card-spacer flex-grow-1">
                  <span
                    className={`symbol symbol-50 symbol-light-secondary mr-2`}
                  >
                    <span className="symbol-label">
                      <span className={`svg-icon svg-icon-xl svg-icon-danger`}>
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Map/Direction2.svg"
                          )}
                        ></SVG>
                      </span>
                    </span>
                  </span>
                  <div className="d-flex flex-column text-right">
                    <span className="text-dark-75 font-weight-bolder font-size-h3">
                      {data?.visibility}
                    </span>
                    <span
                      className="text-muted font-weight-bold mt-2"
                      onClick={() => {
                        setShowVisibility(true);
                        dispatch(
                          fetchVisibility({
                            start_date: _startDate,
                            end_date: _endDate,
                            type: "sales_summary",
                          })
                        );
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      Visibility
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </Col>
          <Col className="mt-3">
            <div className={`card card-custom fixed-height`}>
              <div className="card-body p-0">
                <div className="d-flex align-items-center justify-content-between card-spacer flex-grow-1">
                  <span
                    className={`symbol symbol-50 symbol-light-secondary mr-2`}
                  >
                    <span className="symbol-label">
                      <span className={`svg-icon svg-icon-xl svg-icon-success`}>
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Shopping/Chart-bar1.svg"
                          )}
                        ></SVG>
                      </span>
                    </span>
                  </span>
                  <div className="d-flex flex-column text-right">
                    <span className="text-dark-75 font-weight-bolder font-size-h3">
                      {formatCurrency(data?.revenue)}
                    </span>
                    <span
                      className="text-muted font-weight-bold mt-2"
                      onClick={() => setShow(true)}
                      style={{ cursor: "pointer" }}
                    >
                      Revenue
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>

      <div className="mt-5">
        <Row>
          <Col sm={4}>
            <div className={`card card-custom`}>
              <div className="card-header border-0">
                <h3 className="card-title font-weight-bold text-dark text-base">
                  {" "}
                  {/* smaller text */}
                  Top Customers
                </h3>
              </div>
              <div className="card-body pt-2 custom-scroll text-sm">
                {" "}
                {/* smaller body text */}
                {tableDataCustomer && tableDataCustomer.length > 0 ? (
                  tableDataCustomer.map((item, index) => (
                    <div className="d-flex align-items-center mb-2" key={index}>
                      {" "}
                      {/* reduced margin */}
                      <span className="bullet bullet-bar bg-success align-self-stretch"></span>
                      <div className="d-flex flex-column flex-grow-1 ml-2">
                        {" "}
                        {/* smaller spacing */}
                        <span className="text-dark-75 font-weight-bold font-size-sm mb-1">
                          <NavLink
                            className="menu-link text-sm"
                            to={`/master/customer/edit/${item.customer_id}?additionalParam=OrderHistory&&startDate=${_startDate}&&endDate=${_endDate}`}
                          >
                            <b>{index + 1}</b>.{" "}
                            <b>{item.customer_store_name}</b>
                          </NavLink>
                        </span>
                      </div>
                      <div className="d-flex flex-column flex-grow-1">
                        <span className="text-dark-75 text-hover-primary text-right font-weight-bold font-size-sm mb-1">
                          {formatCurrency(item.revenue)}
                        </span>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="text-center p-4 text-sm">
                    <span className="text-muted">No data available</span>
                  </div>
                )}
              </div>
            </div>
          </Col>

          <Col sm={4}>
            <div className={`card card-custom`}>
              <div className="card-header border-0">
                <h3 className="card-title font-weight-bold text-dark text-base">
                  Top Products
                </h3>
              </div>
              <div className="card-body pt-2 custom-scroll text-sm">
                {tableDataProduct && tableDataProduct.length > 0 ? (
                  tableDataProduct.map((item, index) => (
                    <div className="d-flex align-items-center mb-2" key={index}>
                      <span className="bullet bullet-bar bg-success align-self-stretch"></span>
                      <div className="d-flex flex-column flex-grow-1 ml-2">
                        <span className="text-dark-75 font-weight-bold font-size-sm mb-1">
                          <NavLink
                            className="menu-link text-sm"
                            to={`/master/product/edit/${item.product_id}?additionalParam=History&&startDate=${_startDate}&&endDate=${_endDate}`}
                          >
                            <b>{index + 1}</b>.{" "}
                            <b>
                              {item.product_code} <br /> {item.product_name}
                            </b>
                          </NavLink>
                        </span>
                      </div>
                      <div className="d-flex flex-column flex-grow-1">
                        <span className="text-dark-75 text-hover-primary text-right font-weight-bold font-size-sm mb-1">
                          {formatQuantity(item.quantity)}
                        </span>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="text-center p-4 text-sm">
                    <span className="text-muted">No data available</span>
                  </div>
                )}
              </div>
            </div>
          </Col>

          <Col sm={4}>
            <div className={`card card-custom`}>
              <div className="card-header border-0">
                <h3 className="card-title font-weight-bold text-dark text-base">
                  Top Revenue
                </h3>
              </div>
              <div className="card-body pt-2 custom-scroll text-sm">
                {tableDataSales && tableDataSales.length > 0 ? (
                  tableDataSales.map((item, index) => (
                    <div className="d-flex align-items-center mb-2" key={index}>
                      <span className="bullet bullet-bar bg-success align-self-stretch"></span>
                      <div className="d-flex flex-column flex-grow-1 ml-2">
                        <span className="text-dark-75 font-weight-bold font-size-sm mb-1">
                          <b>{index + 1}</b>.{" "}
                          <b>
                            {item.company_sales_code} <br />
                            {item.company_sales_name}
                          </b>
                        </span>
                      </div>
                      <div className="d-flex flex-column flex-grow-1">
                        <span className="text-dark-75 text-hover-primary text-right font-weight-bold font-size-sm mb-1">
                          {formatCurrency(item.revenue)}
                        </span>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="text-center p-4 text-sm">
                    <span className="text-muted">No data available</span>
                  </div>
                )}
              </div>
            </div>
          </Col>
        </Row>
      </div>

      <div className="mt-5">
        <Card>
          <CardBody>
            <Row>
              <Col md={8}>
                <div style={{ height: "40vh", position: "relative" }}>
                  <Bar data={dataHadrcode} options={options} />
                </div>
              </Col>
              <Col md={4}>
                <div style={{ height: "40vh", position: "relative" }}>
                  <Pie data={dataPie} options={optionsPie} />
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </div>

      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        dialogClassName="modal-70"
      >
        <Modal.Header closeButton>
          <Modal.Title>Detail Visit Statistics</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ToolkitProvider
            keyField="no"
            data={tableDataSales}
            columns={columns}
            search
          >
            {(props) => (
              <div className="mt-5">
                <Row>
                  <Col>
                    <div className="float-right">
                      <SearchBar
                        {...props.searchProps}
                        placeholder="Search .."
                      />
                    </div>
                  </Col>
                </Row>
                <div className="table-container ">
                  <BootstrapTable
                    // wrapperClasses="table-responsive"
                    classes="table table-head-custom table-vertical-center"
                    bootstrap4
                    bordered={true}
                    {...props.baseProps}
                  />
                </div>
              </div>
            )}
          </ToolkitProvider>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showVisibility}
        onHide={handleCloseVisibility}
        size="lg"
        dialogClassName="modal-70"
      >
        <Modal.Header closeButton>
          <Modal.Title>Detail Visibility</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Stepper */}
          <Stepper activeStep={activeStep}>
            <Step label="Visibility Data" />
            <Step label="Customer Sales Details" />
          </Stepper>

          {/* Step 1: Visibility Data */}
          {activeStep === 0 && (
            <ToolkitProvider
              keyField="no"
              data={tableDataVisibility}
              columns={columnsVisibility}
              search
            >
              {(props) => (
                <div className="mt-5">
                  <Row>
                    <Col>
                      <div className="float-right">
                        <SearchBar
                          {...props.searchProps}
                          placeholder="Search .."
                        />
                      </div>
                    </Col>
                  </Row>
                  <div className="table-container">
                    <BootstrapTable
                      classes="table table-head-custom table-vertical-center"
                      bootstrap4
                      bordered
                      {...props.baseProps}
                    />
                  </div>
                </div>
              )}
            </ToolkitProvider>
          )}

          {/* Step 2: Customer Sales Details */}
          {activeStep === 1 && (
            <div>
              <ToolkitProvider
                keyField="no"
                data={tableDataVisibilityPerSales}
                columns={columnsVisibilityPerSales}
                search
              >
                {(props) => (
                  <div className="mt-5">
                    <Row>
                      <Col>
                        <div className="float-right">
                          <SearchBar
                            {...props.searchProps}
                            placeholder="Search .."
                          />
                        </div>
                      </Col>
                    </Row>
                    <div className="table-container">
                      <BootstrapTable
                        classes="table table-head-custom table-vertical-center"
                        bootstrap4
                        bordered
                        {...props.baseProps}
                        expandRow={expandRow}
                      />
                    </div>
                  </div>
                )}
              </ToolkitProvider>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          {activeStep > 0 && (
            <Button variant="secondary" onClick={handlePreviousStep}>
              Previous
            </Button>
          )}
          <Button variant="outline-danger" onClick={handleCloseVisibility}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
